import { RateLocation } from "./rate-location.type";
import { FclRateLocation } from "./rate-location-fcl.model";
import { FclRate } from "../rate-fcl.model";
import { LclRateLocation } from "./rate-location-lcl.model";
import { LclRate } from "../rate-lcl.model";
import { containerLoad } from "../../shared/container/load-types.const";
import { RateLocationBase } from "./rate-location-base.model";
import { LocationMapper } from "../../location/location.mapper";
import { ContainerPrices } from "../../shared/container/container-prices.model";
import { AirRateLocation } from "./rate-location-air.model";

export class RateLocationMapper {
  public static map(data: any): RateLocation {
    if (!data) {
      return null;
    }

    if (!data.discriminator) {
      return new RateLocationBase(
        data.id,
        data.discriminator,
        data.location ? LocationMapper.map(data.location) : null,
        data.comment,
        data.rate
          ? new FclRate(data.rate.id, data.rate.name, containerLoad.fcl)
          : null,
        RateLocationMapper.map(data.parent),
        data.excludedOriginLocations && data.excludedOriginLocations.length
          ? data.excludedOriginLocations.map(RateLocationMapper.map)
          : [],
        data.excludedDestinationLocations &&
          data.excludedDestinationLocations.length
          ? data.excludedDestinationLocations.map(RateLocationMapper.map)
          : [],
      );
    }

    if (data.discriminator === containerLoad.fcl) {
      return new FclRateLocation(
        data.id,
        data.discriminator,
        data.location ? LocationMapper.map(data.location) : null,
        data.comment,
        data.rate
          ? new FclRate(data.rate.id, data.rate.name, containerLoad.fcl)
          : null,
        new ContainerPrices(data.containers),
        RateLocationMapper.map(data.parent),
        data.excludedOriginLocations && data.excludedOriginLocations.length
          ? data.excludedOriginLocations.map(RateLocationMapper.map)
          : [],
        data.excludedDestinationLocations &&
          data.excludedDestinationLocations.length
          ? data.excludedDestinationLocations.map(RateLocationMapper.map)
          : [],
      );
    }

    if (data.discriminator === containerLoad.lcl) {
      return new LclRateLocation(
        data.id,
        data.discriminator,
        data.location ? LocationMapper.map(data.location) : null,
        data.comment,
        data.rate
          ? new LclRate(data.rate.id, data.rate.name, containerLoad.lcl)
          : null,
        data.minPrice || 0,
        data.weightPrice || 0,
        data.measurementPrice || 0,
        data.blPrice || 0,
        RateLocationMapper.map(data.parent),
        data.excludedOriginLocations && data.excludedOriginLocations.length
          ? data.excludedOriginLocations.map(RateLocationMapper.map)
          : [],
        data.excludedDestinationLocations &&
          data.excludedDestinationLocations.length
          ? data.excludedDestinationLocations.map(RateLocationMapper.map)
          : [],
      );
    }

    if (data.discriminator === containerLoad.air) {
      return new AirRateLocation(
        data.id,
        data.discriminator,
        data.location ? LocationMapper.map(data.location) : null,
        data.comment,
        data.rate
          ? new LclRate(data.rate.id, data.rate.name, containerLoad.lcl)
          : null,
        data.minPrice || 0,
        data.weightPriceLt45 || 0,
        data.weightPriceGt45 || 0,
        data.weightPriceGt100 || 0,
        data.weightPriceGt300 || 0,
        data.weightPriceGt500 || 0,
        data.weightPriceGt1000 || 0,
        RateLocationMapper.map(data.parent),
        data.excludedOriginLocations && data.excludedOriginLocations.length
          ? data.excludedOriginLocations.map(RateLocationMapper.map)
          : [],
        data.excludedDestinationLocations &&
          data.excludedDestinationLocations.length
          ? data.excludedDestinationLocations.map(RateLocationMapper.map)
          : [],
      );
    }
  }
}
